<template>
  <div class="login-page">
    <nav class="navbar navbar-transparent navbar-absolute">
      <div class="container">
        <div class="img-wrapper">
          <router-link :to="{ name: 'home' }">
            <img :src="companyLogo" alt="company logo" />
          </router-link>
        </div>
      </div>
    </nav>

    <div class="wrapper wrapper-full-page">
      <div class="full-page" :data-image="fullPageBackground">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3">
                <error-listener />
                <form ref="form" @submit.prevent="resetPasswordForm">
                  <div class="card" data-background="color" data-color="blue">
                    <div class="card-header">
                      <h3 class="card-title">Reset Password</h3>
                    </div>
                    <div class="card-content">
                      <div class="form-group">
                        <label>Username</label>
                        <input
                          placeholder="Enter Username"
                          required
                          type="email"
                          class="form-control input-no-border"
                        />
                      </div>
                    </div>
                    <div class="card-footer text-center">
                      <button
                        type="submit"
                        class="btn btn-fill btn-wd submit-button"
                        :class="{ loading: $wait.waiting(_uid) }"
                      >
                        Send link
                        <i
                          v-show="$wait.waiting(_uid)"
                          class="fas fa-circle-notch loading-icon"
                        />
                      </button>
                      <div class="forgot mt-xxs">
                        <router-link
                          :to="{ name: 'system@login' }"
                          class="text-primary text-2xl"
                        >
                          Already have user and password?
                        </router-link>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer footer-transparent">
          <div class="container">
            <div class="copyright">
              <span
                >&copy; 2006 - {{ year }} {{ reservedRightsWebSite }} All Rights
                Reserved.</span
              >
              <p>{{ getRevision() }}</p>
            </div>
          </div>
        </footer>
        <div
          class="full-page-background"
          :style="`background-image: url(${fullPageBackground})`"
        />
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import label from "@/consts/label";
import { mapGetters, mapActions } from "vuex";
import ErrorListener from "@/components/UIComponents/ErrorListener/ErrorListener";

export default {
  components: { ErrorListener },
  data() {
    return {
      fullPageBackground: "static/img/background/login-page-background.jpg",
      year: moment().year(),
      companyLogo: label.companyLogo,
      reservedRightsWebSite: label.reservedRightsWebSite,
    };
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
  },
  mounted() {},
  methods: {
    ...mapActions("loadingStore", ["setLoading"]),
    ...mapActions("errorStore", ["addNewError"]),
    ...mapActions("userStore", ["resetPassword"]),

    async resetPasswordForm(event) {
      event.preventDefault();
      const [inputEmail] = this.$refs.form;
      const [email] = [inputEmail.value];

      if (!email) {
        return;
      }

      try {
        this.$wait.start(this._uid);
        const response = await this.resetPassword({
          userData: {
            username: inputEmail.value,
          },
        });

        const redirectTo = response.redirectTo;

        if (redirectTo) {
          return window.location.replace(redirectTo);
        }

        this.$notify({
          message: response.message,
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "info",
        });

        return this.$router.push({ name: "system@login" });
      } catch (error) {
        this.addNewError(error);
      } finally {
        this.$wait.end(this._uid);
      }
    },
  },
};
</script>

<style>
.swal2-modal {
  width: 700px !important;
}

.term {
  width: 100%;
  min-height: 57vh;
}

.full-page > .content {
  min-height: calc(100vh - 122px);
}
</style>
